import React from 'react';
import {connect} from 'react-redux'
import {ConfigProvider, DatePicker, Modal, Row} from "antd";
import 'antd/lib/modal/style/css';
import getCRLReasons from "../../actions/getCRLReasons";
import {Button} from "antd";
import moment from "moment";
import esCO from "antd/es/locale/es_ES";
import enUS from "antd/es/locale/en_US";
const { RangePicker } = DatePicker;
const dateFormat = 'YYYY/MM/DD';

class DatesModal extends React.Component {

    state={date:''};

    sendDates=()=>
    {
        let dates=this.state.date;
        if(dates && dates.length===2)
        {
            let dateFrom=dates[0],dateTo=dates[1];
            if(dateFrom && dateTo)
                this.props.onOK({inicio:dateFrom,fin:dateTo});
        }
    };

    render() {
        return (
            <Modal centered visible={this.props.modalType !== null} {...this.props.modalProps}>
                <Row className={'text-center block'}>
                    <strong>{this.props.message} </strong>
                </Row>
                <br />
                <Row className={'text-center block'}>
                    <ConfigProvider locale={this.props.language==='es'?esCO:enUS}>
                        <RangePicker value={this.state.date} style={{ width: 250 }} defaultValue={[moment(moment().toISOString(),dateFormat),moment(moment().toISOString(),dateFormat)]}
                             onChange={(newDate) => this.setState({date:newDate})}/>
                    </ConfigProvider>
                </Row>
                <br />
                <Row className={'text-center block'}>
                    <Button onClick={this.sendDates} type={'primary'}>{this.props.btnOK}</Button>
                    <Button onClick={this.props.onCancel} type={'primary'}>{this.props.btnCancel}</Button>
                </Row>
            </Modal>
        )
    }

}

function mapStateToProps(state) {
    return {
        language: state.auth.language,
        crlReasons:state.certificates.crlReasons
    }
}

export default connect(mapStateToProps, {getCRLReasons})(DatesModal);
